<template>
  <div class="sub-navi-wrapper">
    <div v-for="items in menuItems" :key="items.id"
         :id="items.id"
         :class="[passiveMenuClass,items.active ? activeMenuClass : inactiveMenuClass]">
      <div class="container sub-navi" >
        <div class="close" @click="closeSubMenu"><i class="icon-cross2"></i></div>
        <div class="navi-sub-flex-span"></div>
        <version0 :item="items" />
      </div>
    </div>
  </div>
</template>

<script>

import Version0 from "@/components/Version0";

export default {
  name: 'SubMenu',
  components: {
    'version0': Version0
  },
  data() {
    return {
      // activeMenuClass: 'expand',
      passiveMenuClass: 'container-fluid header-sub',
      activeLinkClass:'active',
      hideSubMenuClass:'hide-submenu',
      showSubMenuClass:'show-submenu'
    }
  },
  methods: {
    showSubContent(event,subItem){
      this.$store.commit('showSubMenuContent',subItem);
    },
    closeSubMenu(){
      this.$store.commit('hideActiveSubMenu');
    },
  },
  computed: {
    menuItems: function () {
      if (this.$store.getters.mainMenu.length){
        return this.$store.getters.mainMenu.filter(mainMenu => mainMenu.hasSub)
      }

      return [];
    },
    activeMenuClass: function () {
      if (this.$store.getters.hasSub){
        return 'expand-no-transition';
      }
      return 'expand';
    },
    inactiveMenuClass: function () {
      if (this.$store.getters.hasSub){
        return 'hide-no-transition';
      }
      return '';
    },

  }
}
</script>
